import { useCallback, useState } from "react";
import { activateScreening } from "../network";

export const useActivateScreening = (
  verification_request_id?: string
): [
  boolean,
  boolean,
  Error | null,
  () => Promise<void>,
  React.Dispatch<React.SetStateAction<Error | null>>
] => {
  const [result, setResult] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async () => {
    if (!verification_request_id) {
      const err = new Error("Verification request id is required");
      setError(err);
      throw err;
    }

    setIsLoading(true);
    setError(null);

    try {
      await activateScreening(verification_request_id);
      setResult((prev) => !prev);
    } catch (e) {
      const err = e instanceof Error ? e : new Error("Unknown error");
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [verification_request_id]);

  return [result, isLoading, error, request, setError];
};
